import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';

@HookClass('report')
export class ReportHook extends BaseHook {

    @Hook('08ba4438-b185-4541-bd3f-b9abd54218e4')
    public report(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('ReportService')
            .pipe(concatMap((service: any) => {
                return service.build(inputArtifact.object.config.reportId, inputArtifact.object.data);
            }));
    }

    @Hook('23c36dc3-bbb4-4057-a246-7a382a1ebebf')
    public report2(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new/client/default'
                            : 'https://report.fluna.io/api/process/start/new/client/default';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/809dfd52-fe32-4717-8636-201799b45f46`,
                                params: {},
                                headers: {
                                    'nick-system': 'ca28f8c0-76db-4be0-b446-bb93f6d63028',
                                    'authorization': this.context.token,
                                    'nick-expire': 6000
                                },
                                body: inputArtifact.object.data
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }
}
